import { Component } from '@angular/core';

import { CmsModalService } from '../../core/modal.service';
import { CmsNotificationsService } from '../../core/notifications.service';
import { CmsNotifyService } from '../../core/notify.service';
import { CmsTranslateService } from '../../shared/translate.service';
import { CmsApplicationSettingsService } from '../application-settings.service';

@Component({
    selector: 'cms-archive-setting',
    templateUrl: 'archive-setting.component.html',
    providers: [CmsApplicationSettingsService]
})
export class CmsArchiveSettingComponent {
    data: number;

    constructor(
        private modalService: CmsModalService,
        private notificationsService: CmsNotificationsService,
        private notifyService: CmsNotifyService,
        private translateService: CmsTranslateService,
        private appSettingsService: CmsApplicationSettingsService
    ) {}

    archiveSetting() {
        this.appSettingsService.archiveSetting(this.data).subscribe(
            () => {
                this.notificationsService.show({
                    type: 'action',
                    content: this.translateService.translate('settings_setting_archive_success')
                });
                this.closePopup();
                this.notifyService.notify('applicationSettingArchive');
            },
            (err: any) => {
                this.notificationsService.show({
                    type: 'error',
                    content: err.message
                });
            }
        );
    }

    closePopup() {
        this.modalService.close('archive-setting');
    }
}
